<template>
  <section class="relative text-white py-20 px-6 bg-no-repeat bg-cover bg-center ">
    <div class="max-w-7xl mx-auto flex flex-col items-center text-center mb-32">
      <!-- Título -->
      <div class="mb-6">
        <h1 class="text-3xl md:text-5xl font-extrabold mb-4">SOBRE NÓS</h1>
        <p class="text-lg mt-2">A Integrator Host fornece o serviço web perfeito para o seu negócio</p>
      </div>



      <!-- Linha separadora -->
      <div class="mb-20"></div>

      <!-- Estatísticas -->
      <div class="grid grid-cols-1 md:grid-cols-3  w-full text-left md:text-center">
        <div>
          <h3 class="text-6xl font-bold text-yellow-400">70K</h3>
          <p class="text-sm mt-4 text-white/90">site e sistemas web <br /> hospedados em nossa estrutura</p>
        </div>
        <div>
          <h3 class="text-6xl font-bold text-yellow-400">25K</h3>
          <p class="text-sm mt-4 text-white/90">clientes que fazem <br /> parte e confiam em nosso serviços</p>
        </div>
        <div>
          <h3 class="text-6xl font-bold text-yellow-400">200M</h3>
          <p class="text-sm mt-4 text-white/90">em acesso <br /> mensais com link  de 50 Gbps</p>
        </div>
      </div>
    </div>
  </section>
</template>
